<div class="modal-header">
  <h3 class="modal-title">Update name</h3>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()" [disabled]="submitted"></button>
</div>

<div class="modal-body">
  <form id="form" (ngSubmit)="submit()" ngNativeValidate>
    <div class="row">
      <div class="col-12 col-md-6">
        <div class="input-group">
          <span class="input-group-text"><label for="firstName"><i class="bi bi-person-vcard"></i></label></span>
          <div class="form-floating">
            <input id="firstName" type="text" name="firstName" [(ngModel)]="firstName" class="form-control" placeholder="First name" autofocus minlength="1" required>
            <label for="firstName">First name</label>
          </div>
        </div>

        <br/>
      </div>

      <div class="col-12 col-md-6">
        <div class="input-group">
          <span class="input-group-text"><label for="lastName"><i class="bi bi-person-vcard"></i></label></span>
          <div class="form-floating">
            <input id="lastName" type="text" name="lastName" [(ngModel)]="lastName" class="form-control" placeholder="Last name" minlength="1" required>
            <label for="lastName">Last name</label>
          </div>
        </div>
        <br/>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="close()" [disabled]="submitted">Cancel</button>
  <button type="submit" class="btn btn-primary" form="form" [disabled]="submitted">
    <span>Submit</span>
    <span *ngIf="submitted" class="spinner-border spinner-border-sm ms-2"></span>
  </button>
</div>
